import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SignInModal from "./SignInModal";
import { useAuth } from "../context/AuthContext";
import { useSignInModal } from "../context/SignInModalContext";
import "./AuthHeader.scss";
import FAQPopover from "./FAQPopover";

interface AuthHeaderProps {
  layout?: "fixed" | "inline";
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ layout = "fixed" }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, signOut } = useAuth();
  const {
    isVisible: isSignInModalVisible,
    openSignInModal,
    closeSignInModal,
  } = useSignInModal();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  // Close user menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      setIsUserMenuOpen(false);
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  const handleViewMyUploads = () => {
    setIsUserMenuOpen(false);
    navigate("/myuploads");
  };

  return (
    <>
      <div className={`auth-header auth-header-${layout}`}>
        <div
          className="auth-container"
          ref={isAuthenticated ? userMenuRef : undefined}
        >
          {isAuthenticated ? (
            <>
              <button
                className="user-email-btn"
                onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                title="User menu"
              >
                {user?.email}
              </button>
              {isUserMenuOpen && (
                <div className="user-dropdown-menu">
                  <button
                    className="dropdown-item"
                    onClick={handleViewMyUploads}
                  >
                    View My Uploads
                  </button>
                  <button
                    className="dropdown-item sign-out-item"
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </>
          ) : (
            <button className="sign-in-btn" onClick={() => openSignInModal()}>
              Sign In
            </button>
          )}
          <FAQPopover />
        </div>
      </div>

      <SignInModal
        isVisible={isSignInModalVisible}
        onClose={() => closeSignInModal()}
        onSignInSuccess={() => {
          closeSignInModal();
        }}
      />
    </>
  );
};

export default AuthHeader;
